var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1986 6.33203L10.5007 9.02995L7.80273 6.33203L6.33398 7.80078L9.0319 10.4987L6.33398 13.1966L7.80273 14.6654L10.5007 11.9674L13.1986 14.6654L14.6673 13.1966L11.9694 10.4987L14.6673 7.80078L13.1986 6.33203ZM10.5007 0.0820312C4.74023 0.0820312 0.0839844 4.73828 0.0839844 10.4987C0.0839844 16.2591 4.74023 20.9154 10.5007 20.9154C16.2611 20.9154 20.9173 16.2591 20.9173 10.4987C20.9173 4.73828 16.2611 0.0820312 10.5007 0.0820312ZM10.5007 18.832C5.9069 18.832 2.16732 15.0924 2.16732 10.4987C2.16732 5.90495 5.9069 2.16536 10.5007 2.16536C15.0944 2.16536 18.834 5.90495 18.834 10.4987C18.834 15.0924 15.0944 18.832 10.5007 18.832Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.d7b89cfa08ec412c0b576c5400384dc3.svg";
export { ForwardRef as ReactComponent };